import moment from 'moment';
import { atom } from 'recoil';

import { momentTz } from '../../app/components/subheader/components/DatePicker';
import { getSearchString } from '../../common/helperFunctions/getSearchString';

export const getStartingDate = (isNewDateRange?: boolean) => {
  const urlParams = getSearchString(isNewDateRange);

  return urlParams.get('start')
    ? momentTz(
        urlParams.get('start') ?? moment().format('YYYY-MM-DD'), // set end date if set in url query
        urlParams.get('tz') // set timezone if set in url query
      )
    : momentTz(
        moment().format('YYYY-MM-DD'), // set timezone if set in url query
        urlParams.get('tz')
      ).subtract('days', isNewDateRange ? 7 : 29); // default value (aka initial value)
};

export const startingDate = atom({
  key: 'startingDate', // unique ID (with respect to other atoms/selectors)
  default: getStartingDate(),
});
